import * as ApiConstants from '../constants/Api'
import * as MiscConstants from '../constants/Misc'
import { createSelector } from 'reselect'
import dayjs from 'dayjs'
import get from 'lodash/get'

export default (state = {}, action) => {
  switch (action.type) {
    case ApiConstants.POST_PHONE_UPDATE_REQUEST_PENDING:
      return { ...state, loading: true }

    case ApiConstants.POST_PHONE_UPDATE_REQUEST_SUCCESS:
      return { ...state, ...action.payload, phone_number: action.meta.phone_number, loading: false }

    case ApiConstants.POST_PHONE_UPDATE_REQUEST_REJECT:
      return { error: action.payload.message, loading: false }

    case MiscConstants.RESET_PHONE_UPDATE:
      return {}

    default:
      return state
  }
}

const getPhoneRequestSelector = state => state.phone.request

export const phoneRequestSelector = createSelector([getPhoneRequestSelector], data => ({
  ...data,
  nextAttempt: dayjs()
    .add(get(data, 'next_attempt_in', 0), 's')
    .unix()
}))
